import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('subject', formData.subject);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d56jbaeisj01hmefqee0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 px-4 bg-[#0a0e1a]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            İletişim
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Sorularınız mı var? Bize ulaşın, size yardımcı olmaktan mutluluk duyarız
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-xl p-8 border border-[#3b82f6]/20 mb-8">
              <h3 className="text-2xl font-bold text-white mb-6">Bize Ulaşın</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-discord-fill text-2xl text-[#3b82f6]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Discord</h4>
                    <p className="text-gray-400 text-sm mb-2">Wino5DJ Studios Resmi Discord Sunucusu</p>
                    <a href="https://discord.gg/7MzuPKd9SD" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] hover:text-[#2563eb] transition-colors">
                      discord.gg/7MzuPKd9SD
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-2xl text-[#3b82f6]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">E-posta</h4>
                    <p className="text-gray-400 text-sm mb-2">Detaylı sorularınız için</p>
                    <a href="mailto:info@minecraft-server.com" className="text-[#3b82f6] hover:text-[#2563eb] transition-colors">
                      info@minecraft-server.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-[#3b82f6]/20 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-youtube-fill text-2xl text-[#3b82f6]"></i>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">YouTube</h4>
                    <p className="text-gray-400 text-sm mb-2">Videolar ve içerikler</p>
                    <a href="https://www.youtube.com/@Windo5DJ" target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] hover:text-[#2563eb] transition-colors">
                      @Windo5DJ
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-xl p-8 border border-[#3b82f6]/20">
              <h3 className="text-2xl font-bold text-white mb-4">Sık Sorulan Sorular</h3>
              <div className="space-y-4">
                <div>
                  <h4 className="text-white font-semibold mb-2">Sunucuya nasıl katılabilirim?</h4>
                  <p className="text-gray-400 text-sm">Minecraft'ı açın, Multiplayer seçeneğine tıklayın ve sunucu adresimizi ekleyin.</p>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Hangi versiyonları destekliyorsunuz?</h4>
                  <p className="text-gray-400 text-sm">1.16.5 - 1.20.4 arası tüm versiyonları destekliyoruz.</p>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Premium hesap gerekli mi?</h4>
                  <p className="text-gray-400 text-sm">Evet, sunucumuza katılmak için orijinal Minecraft hesabı gereklidir.</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <form 
              id="contact-form"
              data-readdy-form
              onSubmit={handleSubmit} 
              className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-xl p-8 border border-[#3b82f6]/20"
            >
              <h3 className="text-2xl font-bold text-white mb-6">Mesaj Gönderin</h3>
              
              <div className="space-y-5">
                <div>
                  <label htmlFor="name" className="block text-white font-semibold mb-2">
                    İsim
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                    className="w-full bg-[#0a0e1a] border border-[#3b82f6]/20 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#3b82f6] transition-colors text-sm"
                    placeholder="Adınız"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-white font-semibold mb-2">
                    E-posta
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                    className="w-full bg-[#0a0e1a] border border-[#3b82f6]/20 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#3b82f6] transition-colors text-sm"
                    placeholder="ornek@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="subject" className="block text-white font-semibold mb-2">
                    Konu
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    required
                    className="w-full bg-[#0a0e1a] border border-[#3b82f6]/20 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#3b82f6] transition-colors text-sm"
                    placeholder="Mesajınızın konusu"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-white font-semibold mb-2">
                    Mesaj
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={(e) => {
                      if (e.target.value.length <= 500) {
                        setFormData({...formData, message: e.target.value});
                      }
                    }}
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full bg-[#0a0e1a] border border-[#3b82f6]/20 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#3b82f6] transition-colors resize-none text-sm"
                    placeholder="Mesajınızı buraya yazın..."
                  />
                  <div className="text-right text-gray-500 text-xs mt-1">
                    {formData.message.length}/500
                  </div>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-[#3b82f6] to-[#2563eb] text-white px-6 py-3 rounded-lg font-semibold hover:from-[#2563eb] hover:to-[#1d4ed8] transition-all duration-200 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center">
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Gönderiliyor...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center">
                      <i className="ri-send-plane-fill mr-2"></i>
                      Mesaj Gönder
                    </span>
                  )}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-[#3b82f6]/20 border border-[#3b82f6] rounded-lg p-4 text-center">
                    <i className="ri-checkbox-circle-line text-[#3b82f6] text-2xl mb-2"></i>
                    <p className="text-white font-semibold">Mesajınız başarıyla gönderildi!</p>
                    <p className="text-gray-400 text-sm mt-1">En kısa sürede size dönüş yapacağız.</p>
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-500/20 border border-red-500 rounded-lg p-4 text-center">
                    <i className="ri-error-warning-line text-red-500 text-2xl mb-2"></i>
                    <p className="text-white font-semibold">Bir hata oluştu!</p>
                    <p className="text-gray-400 text-sm mt-1">Lütfen daha sonra tekrar deneyin.</p>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
